import { formatDiscountDisplay } from '@/lib/discount';

interface DiscountBadgeProps {
  discountType: 'fixed' | 'percentage';
  discountAmount: number;
  className?: string;
}

export function DiscountBadge({ discountType, discountAmount, className = '' }: DiscountBadgeProps) {
  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-bold bg-red-500 text-white ${className}`}>
      {formatDiscountDisplay(discountType, discountAmount)}
    </div>
  );
}